module.exports = __webpack_public_path__ + "img/dataset_filters.97231072.png";